export default __webpack_public_path__ + "static/media/avatar-2.4c55a7c8.png";